import { FirebaseAuthentication } from 'services/firebase';

const sendVerificationEmail = async () => {
  const auth = FirebaseAuthentication();

  await auth.currentUser.sendEmailVerification();
};

export default sendVerificationEmail;
